export const allowedProvider = [
    'facebook',
    'glomex',
    'instagram',
    'kwiss',
    'opinary',
    'pinterest',
    'reddit',
    'spotify',
    'sso',
    'sso_whatsapp',
    'tiktok',
    'twitter',
    'youtube',
] as const;

export type Provider = typeof allowedProvider[number];
/**
 * Provider type that accepts string and can be narrowed
 */
export type ProviderInput = Provider | (string & {});

export function isAllowedProvider(provider: Provider | string): provider is Provider {
    return allowedProvider.includes(provider as Provider)
}
